import sanityClient from '@sanity/client'

    export default sanityClient ({
        projectId: "ei5784pj",
        dataset: "production",
        apiVersion: '2022-06-01'
    })
